import "./style.css";

export default class EventsOverview {
  static selector = ".events-overview";
  x0 = null;
  x = 0;
  index = 0;

  constructor(block) {
    this.block = block;

    let ulWrapper = this.block.querySelector("ul.events-overview__events-list-inner");
    ulWrapper.addEventListener("click", this.onClick);
    ulWrapper.addEventListener("touchstart", this.onTouchStart);
    ulWrapper.addEventListener("touchmove", this.onTouchMove, {
      passive: false
    });
    ulWrapper.addEventListener("touchend", this.onTouchEnd);
    ulWrapper.addEventListener("mousedown", this.onTouchStart);
    ulWrapper.addEventListener("mousemove", this.onTouchMove, {
       passive: false
    });
    ulWrapper.addEventListener("mouseup", this.onTouchEnd);

    this.backgroundImages = this.block.querySelectorAll(
      ".events-overview__event-date-wrapper .bg_image"
    );
    this.setupBackgroundImages();

    this.arrows = this.block.querySelectorAll(
      ".events-overview__arrows .arrows a"
    );
    this.arrows.forEach(arrow => {
      arrow.addEventListener("click", this.onArrowClick);
    });

    window.addEventListener("load", this.onResize);
  }

  setupBackgroundImages = () => {
    this.backgroundImages.forEach(backgroundImage => {
      const backgroundUrl = backgroundImage.dataset.large;
      let image = new Image();
      image.onload = () => {
        const large = backgroundImage.nextElementSibling;
        large.style.backgroundImage = "url('" + backgroundUrl + "')";
        large.classList.add("image--large--loaded");
      };
      image.src = backgroundUrl;
    });
  };  

  ellipsizeTextBox = el => {
    if (el.ellipsizeWidth && el.ellipsizeWidth === el.offsetWidth) {
      return;
    }

    if (!el.originalWords) {
      el.originalWords = el.innerText.split(" ");
    } else {
      el.innerText = el.originalWords.join(" ");
    }

    el.ellipsizeWidth = el.offsetWidth;

    const wordArray = [...el.originalWords];
    while (el.scrollHeight > el.offsetHeight) {
      wordArray.pop();
      el.innerHTML = wordArray.join(" ") + "&hellip;";
    }
  };

  updateIndex = value => {
    this.index = value;
    let liLength = this.block.querySelectorAll(
      "ul.events-overview__events-list-inner li.events-overview__event"
    ).length;

    this.arrows.forEach(arrow => {
      if (
        (arrow.dataset.operator === "-" && this.index === 0) ||
        (arrow.dataset.operator === "+" &&
          Math.abs(this.index) === liLength - 1)
      ) {
        arrow.classList.add("disabled");
      } else {
        arrow.classList.remove("disabled");
      }
    });
  };

  onClick = e => {
    if (this.dragging) {
      e.preventDefault();
    }
  };

  onArrowClick = e => {
    e.preventDefault();
    let ul = this.block.querySelector("ul.events-overview__events-list-inner");
    let liLength = ul.querySelectorAll(
      "li.events-overview__event"
    ).length;
    let li = ul.querySelector("li.events-overview__event");
    let liWidth = li.offsetWidth;
    let liHeight = li.offsetHeight + 23;
    const operator = e.currentTarget.dataset.operator;

    if (liLength < 2) {
      return false;
    }

    this.index = operator === "+" ? this.index - 1 : this.index + 1;
    this.index = this.clamp(this.index, -(liLength - 1), 0);
    ul.style.transform = "translateX(" + this.index * liWidth + "px)";

    this.updateIndex(this.index);
  };

  updateCarousel = () => {
    let ul = this.block.querySelector("ul.events-overview__events-list-inner");
    let liLength = ul.querySelectorAll("li.events-overview__event").length;

    if (liLength < 1) {
      return;
    }

    let li = ul.querySelector("li");
    let liWidth = li.offsetWidth;
    let liHeight = li.offsetHeight + 23;
    let index = this.index;

    index = this.clamp(index, -(liLength - 1), 0);
    ul.style.transform = "translateX(" + index * liWidth + "px)";

    this.updateIndex(index);
  };

  onTouchStart = e => {
    let node = e.target;

    this.dragging = false;
    this.x0 = (e.touches && e.touches[0] && e.touches[0].clientX) || e.clientX;
    this.firstClientX = this.x0;
    this.firstClientY =
      (e.touches && e.touches[0] && e.touches[0].clientY) || e.clientY;
  };

  onTouchMove = e => {
    let node = e.target;

    //prevent drag and scroll
    const minValue = 5; // threshold
    this.dragging = true;

    let x = (e.touches && e.touches[0] && e.touches[0].clientX) || e.clientX;
    let y = (e.touches && e.touches[0] && e.touches[0].clientY) || e.clientY;

    this.clientX = x - this.firstClientX;
    this.clientY = y - this.firstClientY;

    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(x) > minValue && e.cancelable) {
      //do not scroll
      e.preventDefault();
    } else {
      //scroll
      return;
    }

    const index = this.index;
    const x0 = this.x0;
    const li = e.currentTarget.querySelector(
      "li.events-overview__event"
    );
    //const liMarginRight = window.innerWidth > tablet ? 25 : 15;
    const liWidth = li.offsetWidth;

    if (x0 === null) {
      return;
    }

    const ul = e.currentTarget;
    const value = x - x0 + index * liWidth;
    ul.style.transform = "translateX(" + value + "px)";
    ul.style.transition = "none";

    this.x = x;
  };

  clamp = (val, min = 0, max = 1) => Math.max(min, Math.min(max, val));

  onTouchEnd = e => {
    let node = e.target;

    let index = this.index;
    const dX = this.x - this.x0;
    
    const ul = e.currentTarget;
    const li = e.currentTarget.querySelector(
      "li.events-overview__event"
    );
    const liWidth = li.offsetWidth;
    const itemsLength = e.currentTarget.querySelectorAll(
      "li.events-overview__event"
    ).length;

    index += Math.round(dX / liWidth);
    index = this.clamp(index, -(itemsLength - 1), 0);

    this.x0 = null;

    //ul.classList.remove('p-e--none');

    this.updateIndex(index);
    ul.style.transition = null;
    ul.style.transform = "translateX(" + index * liWidth + "px)";
  };

  onResize = () => {
    this.updateCarousel();
  };
}
